<script lang="ts">
  import Creation from './ecrans/Creation.svelte'
  import Fiche from './ecrans/Fiche.svelte'
  import Personnages from './ecrans/Personnages.svelte'
  import { routeCourante, type Route } from './routage'

  let { erreur }: { erreur: string | null } = $props()

  let route = $state<Route>(routeCourante())

  // Le fragment d'URL est la seule source de vérité de la navigation : le
  // bouton « précédent » du navigateur fonctionne alors sans code de plus.
  $effect(() => {
    const suivre = () => (route = routeCourante())
    window.addEventListener('hashchange', suivre)
    return () => window.removeEventListener('hashchange', suivre)
  })
</script>

<div class="page">
  {#if erreur}
    <main class="panne">
      <h1 class="gothique">Legacy of the Crown</h1>
      <p role="alert">
        Le référentiel n'a pas pu être chargé.<br />
        <code>{erreur}</code>
      </p>
      <p class="note">
        Le moteur refuse de démarrer plutôt que de calculer faux. C'est voulu.
      </p>
    </main>
  {:else if route.ecran === 'creation'}
    <Creation />
  {:else if route.ecran === 'fiche'}
    <Fiche id={route.id} />
  {:else}
    <Personnages />
  {/if}
</div>

<style>
  .page {
    background: var(--bg);
    color: var(--ink);
    min-height: 100dvh;
    padding: calc(var(--pas) * 5) calc(var(--pas) * 5) calc(var(--pas) * 12);
    box-sizing: border-box;
    max-width: 78rem;
    margin: 0 auto;
  }

  .panne h1 {
    font-size: clamp(2rem, 8vw, 3.5rem);
    color: var(--accent);
    margin: 0 0 calc(var(--pas) * 4);
  }
  .panne p {
    border-left: 3px solid var(--ko);
    padding-left: calc(var(--pas) * 3);
    color: var(--ko);
    max-width: 60ch;
  }
  .panne .note {
    border-color: var(--line);
    color: var(--ink-soft);
  }
</style>
